<script setup>
  import { ref, onMounted, getCurrentInstance } from 'vue'
  import { useRouter } from 'vue-router'
  import {usePageLoadingStore} from "../../../../../stores/pageLoading";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
  import MyPageResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
  import { useAlertStore } from "../../../../../stores/alertStore";
  import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
  import SearchResidenceModal from "../../../components/modal/matching/SearchResidenceModal.vue";
  import mypageUserResumeService from "@/pages/user/services/mypage/mypageUserResumeService";
  import {storeToRefs} from "pinia";
  import {useUserStore} from "@/pages/user/stores/user";
  import moment from "moment/moment";
  const { $alert, $confirm } = useAlertStore();
  const userStore = useUserStore();
  const { user } = storeToRefs(userStore);

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { $pageListBoardNo } = globals;
  const data_interests = ref(globals.$interests)
  const data_schoolGb = ref(globals.$schoolGb)
  const data_eduTenureGb = ref(globals.$eduTenureGb)
  const data_majorGb = ref(globals.$majorGb)

  const userMatchingResumeModal = ref(null);
  const searchResidenceModal = ref(null) // 지역 선택 모달

  // 전공계열(주전공) 펼침/닫힘
  const spreadMajorGbClass = ref('min');

  const router = useRouter()
  const loadingStore = usePageLoadingStore()

  onMounted(()=>{
    retrieveList()
  })

  const interestGbListRef = ref(null)
  const schoolGbListRef = ref(null)
  const eduTenureGbListRef = ref(null)
  const majorGbListRef = ref(null)
  const datepickerTermsRef = ref(null)
  const list = ref([])
  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const searchOpen = ref(true)


  const initialSearchInput = {
    searchDurationType: 'all', // 입사지원일
    startYmd: '',
    endYmd: '',
    searchResidences: [], //거주 지역
    searchInterests: data_interests.value.map(item => item.value), // 관심 카테고리
    searchSchoolGbs: data_schoolGb.value.map(item => item.value), // 최종학력
    searchEduTenureGbs: data_eduTenureGb.value.map(item => item.value), // 최종학력 상태
    searchMajorGbs: data_majorGb.value.map(item => item.value), // 전공계열(주전공)
  };

  const searchInput = ref({ ...initialSearchInput });

  const searchDurationTypeGroup = ref([
    { label:"모든 기간", value: "all" },
    { label:"기간 검색", value: "term" },
  ])

  const pageSizeGroup = ref([
    { label:"10개씩 보기", value: "10" },
    { label:"30개씩 보기", value: "30" },
    { label:"50개씩 보기", value: "50" },
    { label:"100개씩 보기", value: "100" },
    { label:"500개씩 보기", value: "500" },
  ])

  const getParamObj = () => {
    return {
      startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
      endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
      searchResidences: searchInput?.value.searchResidences?.join(',') || "",
      searchInterests: searchInput?.value.searchInterests?.join(',') || "",
      searchSchoolGbs: searchInput?.value.searchSchoolGbs?.join(',') || "",
      searchEduTenureGbs: searchInput?.value.searchEduTenureGbs?.join(',') || "",
      searchMajorGbs: searchInput?.value.searchMajorGbs?.join(',') || "",
      pageNumber: currentPage.value || 0,
      size: pageSize.value || 10,
    };
  }

  // 조건에 맞는 데이터 불러오는 함수
  const retrieveList = () => {
    let paramObj = getParamObj();
    loadingStore.loading = true;
    mypageUserResumeService.retrieveMatchingApplicantListPagingByCorpId(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            totalPages.value = result.totalPages;
            totalCount.value = result.totalElements;
            list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
          } else {
          }
        }).catch( (res) =>  {
          $alert(["데이터를 받아오지 못했습니다.기업코드 등록여부를 확인해주세요."]);
          console.log( res );
          loadingStore.loading = false;
        });
  }

  // 페이지당 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  // 페이지 클릭
  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 검색 버튼
  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  // 초기화 버튼
  const clearSearchInput = () => {
    Object.assign(searchInput.value, initialSearchInput);
    datepickerTermsRef.value.initDates();

    if (interestGbListRef.value && interestGbListRef.value.initOptions) {
      interestGbListRef.value.initOptions();
    }
    if (schoolGbListRef.value && schoolGbListRef.value.initOptions) {
      schoolGbListRef.value.initOptions();
    }
    if (eduTenureGbListRef.value && eduTenureGbListRef.value.initOptions) {
      eduTenureGbListRef.value.initOptions();
    }
    if (majorGbListRef.value && majorGbListRef.value.initOptions) {
      majorGbListRef.value.initOptions();
    }
  }

  // 채용 이력서 보기
  const onClickViewResume = async (resumeId) => {
    // alert("이력서 보기 : " + resumeId);
    userMatchingResumeModal.value.init(false);
    userMatchingResumeModal.value.retrieveUserMatchingResumeDetail(resumeId, 1);
    const res = await userMatchingResumeModal.value.show();
    if(!res) {
      retrieveList();
    }
  }

  const downloadUserResumeList = () => {
    loadingStore.loading = true;

    let paramObj = {
      corpId: user.value.userInfo.corporation.corpId,
    }

    mypageUserResumeService.retrieveApplicantListExcelByCorpId(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          try {
            const href = URL.createObjectURL(res.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', `${moment().format("YYYYMMDD")}_입사지원리스트.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
          } catch(e) {
            console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
          }
        }).catch( (err) =>  {
      loadingStore.loading = false;
      let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
      const errorData = err?.response?.data;

      if (errorData && typeof errorData.text === 'function') {
        // Blob 응답 처리
        errorData.text()  // Blob을 텍스트로 변환
          .then((text) => {
            try {
              // 텍스트를 JSON으로 파싱
              const responseData = JSON.parse(text);
              // 메시지 추출
              if (responseData?.result?.message) {
                errorMessage = responseData.result.message;
              }
            } catch (parseError) {
              console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
            }
            // Toast에 에러 메시지 표시
            $toast('error', errorMessage);
          });
      } else {
        if (errorData?.result?.message) {
          errorMessage = errorData.result.message;
        }
        $toast('error', errorMessage);
      }
    });
  }

  // 엑셀 다운로드
  const onClickExcelDownload = async () => {
    if(totalCount.value > 0) {
      const ok = await $confirm(["입사지원 목록을 내PC로 다운로드할까요?"], "다운로드");
      if(ok){
        downloadUserResumeList();
      }
    } else {
      $alert(["다운로드 받을 '입사지원 목록'이 존재하지 않습니다."]);
      return false;
    }
  }

  // 검색 - 지역 선택 - 모달 띄우기
  const showSearchResidenceModal = () => {
    searchResidenceModal.value.show(searchInput.value.searchResidences);
  }

  // 검색 - 지역 선택 - 자식 컴포넌트에서 데이터 수신
  const handleSelectionSubmit = (selectedResult) => {
    searchInput.value.searchResidences = selectedResult;
  };

  // 검색 - 지역 선택 - 선택 지역 삭제
  const deleteResidence = (residence) => {
    searchInput.value.searchResidences = searchInput.value.searchResidences.filter(
        (item) => item !== residence
    );
  };

  // 검색 - 전공계열(주전공) 펼침/닫힘
  const spreadMajorGb = () => {
    spreadMajorGbClass.value = spreadMajorGbClass.value === 'min' ? '' : 'min'
  }

  // 입사지원 상태변경
  const onClickApplyStateGb = async (corpId, resumeId, stateGb) => {
    let ok;

    if (stateGb === "02") {
      ok = await $confirm(["지원취소 처리하시겠습니까?", "'지원취소'으로 상태가 변경됩니다."], "지원취소");
    } else if (stateGb === "03") {
      ok = await $confirm(["서류합격 처리하시겠습니까?", "'서류합격'으로 상태가 변경됩니다."],"서류합격");
    } else if (stateGb === "04") {
      ok = await $confirm(["서류불합격 처리하시겠습니까?", "'서류불합격'으로 상태가 변경됩니다."], "서류불합격");
    } else if (stateGb === "05") {
      ok = await $confirm(["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."], "최종합격");
    } else if (stateGb === "06") {
      ok = await $confirm(["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."], "최종불합격");
    }

    if(!ok) {
      return -1;
    } else {
      let paramObj = {
        corpId: corpId,
        resumeId: resumeId,
        applyStateGb: stateGb,
      }
      mypageUserResumeService.updateApplyStateGb(paramObj)
          .then( (res) => {
            loadingStore.loading = false;
            if(res.data.code.toLowerCase() === 'success') {
              $alert("변경하였습니다.");

              retrieveList();
            } else {
              $alert("변경을 실패하였습니다.");
              console.log(res);
            }
          })
          .catch( (res) =>  {
            loadingStore.loading = false;
            $alert("변경을 실패하였습니다.");
          });
    }
  }
</script>
<template>
  <div>
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt>입사지원일</dt>
          <dd>
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="item.value" >
                <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                    ref="datepickerTermsRef"
                    :startDate="searchInput.startYmd"
                    :endDate="searchInput.endYmd"
                    @update:startDate="(value)=> searchInput.startYmd = value"
                    @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>거주 지역</dt>
          <dd class="residence-selected">
            <button @click="showSearchResidenceModal()"><i>+</i>지역 선택</button>
            <span v-for="option in searchInput.searchResidences" :key="option">
                {{ option }}<i @click="deleteResidence(option)">삭제</i>
            </span>
          </dd>
        </dl>
        <dl>
          <dt>관심 카테고리</dt>
          <dd>
            <KSACheckBoxGroup
                ref="interestGbListRef"
                className="mr-md"
                name="searchInterests"
                v-model="searchInput.searchInterests"
                :options="data_interests" />
          </dd>
        </dl>
        <dl>
          <dt>최종학력</dt>
          <dd>
            <KSACheckBoxGroup
                ref="schoolGbListRef"
                className="mr-md"
                name="searchSchoolGbs"
                v-model="searchInput.searchSchoolGbs"
                :options="data_schoolGb" />
          </dd>
        </dl>
        <dl>
          <dt>최종학력 상태</dt>
          <dd>
            <KSACheckBoxGroup
                ref="eduTenureGbListRef"
                className="mr-md"
                name="searchEduTenureGbs"
                v-model="searchInput.searchEduTenureGbs"
                :options="data_eduTenureGb" />
          </dd>
        </dl>
        <dl style="align-items: start;">
          <dt>전공계열(주전공)</dt>
          <dd class="majorGb" :class="spreadMajorGbClass">
            <button @click="spreadMajorGb">34개 <i></i></button>
            <KSACheckBoxGroup
                ref="majorGbListRef"
                className="mr-md"
                name="searchMajorGbs"
                v-model="searchInput.searchMajorGbs"
                :options="data_majorGb" />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount) }}</span>명</p>
      <div class="list-top mb-n-xs" style="margin-left: auto;">
        <KSAPrimaryButton v-if="list.length > 0" text="이력서 다운로드(엑셀)" @click="onClickExcelDownload" class="mr-xs" />
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
      </div>
    </div>
    <div class="table-form board-mobile-vertical">
      <table>
        <tr>
          <th>번호</th>
          <th>이름</th>
          <th>관심 카테고리</th>
          <th>이력서보기</th>
          <th>입사 지원일</th>
          <th>상태</th>
          <th>상태변경</th>
        </tr>
        <tr v-for="resumeList in list">
          <td data-title="번호 : ">{{ resumeList.boardNo }}</td>
          <td data-title="이름 : ">{{ resumeList.userName }}</td>
          <td data-title="관심 카테고리 : ">{{ resumeList.interests }}</td>
          <td data-title="이력서 보기 : ">
            <KSATextButton class="clickable resume" text="이력서 보기" @click="onClickViewResume(resumeList.resumeId)"/>
          </td>
          <td data-title="입사 지원일 : ">{{ $yyyymmddHHmmss(resumeList.createDate) }}</td>
          <td data-title="상태 : ">
            <span v-if="resumeList.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',resumeList.applyStateGb) }}</span>
            <span v-else-if="resumeList.applyStateGb === '03' || resumeList.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',resumeList.applyStateGb) }}</span>
            <span v-else-if="resumeList.applyStateGb === '04' || resumeList.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',resumeList.applyStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',resumeList.applyStateGb) }}</span>
          </td>
          <td data-title="상태변경 : ">
            <div v-if="resumeList.applyStateGb === '01'">
              <KSATextButton class="clickable black_button" text="서류합격" @click="onClickApplyStateGb(resumeList.corpId, resumeList.resumeId, '03')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="서류불합격" @click="onClickApplyStateGb(resumeList.corpId, resumeList.resumeId, '04')"/>
            </div>
            <div v-else-if="resumeList.applyStateGb === '03'">
              <KSATextButton class="clickable black_button" text="최종합격" @click="onClickApplyStateGb(resumeList.corpId, resumeList.resumeId, '05')"/>
              &nbsp;
              <KSATextButton class="clickable black_button" text="최종불합격" @click="onClickApplyStateGb(resumeList.corpId, resumeList.resumeId, '06')"/>
            </div>
            <div v-else>
              -
            </div>
          </td>
        </tr>
        <tr v-if="list.length === 0">
          <td colspan="7">입사지원 내역이 없습니다.</td>
        </tr>
      </table>
    </div>
    <Paginate
        v-if="list.length > 0"
        v-model="currentPage"
        :page-count="totalPages"
        :click-handler="onSelectPage"
    />
  </div>
  <MyPageResumeModal ref="userMatchingResumeModal"/>
  <SearchResidenceModal ref="searchResidenceModal" @submitSelection="handleSelectionSubmit"/>
</template>

<style scoped lang="scss">
  @import "../../../../../assets/scss/theme";

  .tab {
    grid-template-columns: repeat(2, 1fr);
  }

  .blue {
    color: $blue_color;
  }
  .red {
    color: $red_color;
  }
  .gray {
    color: $gray_color;
  }

  .clickable {
    cursor: pointer;
    text-decoration: underline;
    &.resume {
      color: #3C72FF;
      &:hover {
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
</style>

